import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "SignalArrow",
  "use": "SignalArrow-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"SignalArrow\"><path fill-rule=\"evenodd\" d=\"M39.402 31.604L35.4 35.6l3.033 3.031 9.082-9.07-3.088-2.975-.244-.243v-.014h-.013l-6.402-6.392-3.032 3.031L38.1 26.33H20.364v15.823h5.313V31.604h13.725zM34.122 2.58l27.298 27.3a3 3 0 0 1 0 4.242L34.12 61.42a3 3 0 0 1-4.242 0L2.58 34.12a3 3 0 0 1 0-4.242L29.88 2.58a3 3 0 0 1 4.242 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol